/**
 * LE REGOLE DI STAMPA E CONDIVISIONE di chi guarda.
 *
 * Le scrive il backoffice (Sito › Impostazioni schedina › 10 · Stampa e
 * condivisione) e le risolve il servizio, nodo per nodo, il piu' vicino
 * vince: arrivano gia' pronte come `stampa` dentro il profilo di gioco (chi ha
 * fatto l'accesso) o dentro la schedina pubblica della skin (chi no).
 *
 *   { stampaGiocata, stampaPrenotazione, formato, logo, condivisioneGiocata,
 *     condivisionePrenotazione, importi, giocaAncheTu,
 *     canali: { whatsapp, telegram, signal, email, sms, x, facebook, viber,
 *               copia, immagine, altro } }
 *
 * DI CHI SONO. Di chi STAMPA, mai del cliente servito: l'agenzia che stampa
 * la giocata di un suo giocatore stampa sul SUO rotolo. Per questo il
 * profilo si legge con `senzaContesto`: la schedina intanto puo' mostrare le
 * quote del giocatore scelto, e i colori di quelle quote non si toccano.
 *
 * NIENTE DEPOSITO PER LA SESSIONE: le regole si leggono una volta per ogni
 * pagina che le chiede (e di nuovo se cambia chi guarda). Un deposito
 * terrebbe le regole vecchie dopo un cambio nel backoffice, e quelle di un
 * altro dopo un cambio di conto.
 *
 * SENZA `stampa` (un servizio di prima): null, e chi disegna non mostra ne'
 * Stampa ne' Condividi.
 */
import {useEffect, useState} from 'react';
import {caricaProfilo, caricaSchedinaSkin} from './profiloDiGioco';

/** Le regole dentro un profilo o una schedina pubblica, o null se il servizio non le manda. */
export function regoleDi(profiloOSchedina) {
  const s = profiloOSchedina && profiloOSchedina.stampa;
  return s && typeof s === 'object' && !Array.isArray(s) ? s : null;
}

/** Legge le regole: il profilo di `io`, o la schedina della skin per chi non e' collegato. */
export function leggiRegoleStampa(io) {
  const lettura = io
    ? caricaProfilo(io, 'PREMATCH', undefined, {senzaContesto: true})
    : caricaSchedinaSkin({senzaContesto: true});
  return Promise.resolve(lettura).then(regoleDi, () => null);
}

/**
 * Le regole di chi guarda, lette una volta per montaggio (e di nuovo se
 * cambia `io`). Null finche' non arrivano, e null se non ci sono.
 *
 * @param io        chi guarda (getCurrentUserId), o null per l'ospite
 * @param opzioni   {carica: false} per non leggere niente (e tornare null):
 *                  serve a chi le vuole solo in certi momenti, come la
 *                  schedina dell'agenzia mentre la prenotazione e' aperta
 */
export function useRegoleStampaConStato(io, {carica = true} = {}) {
  /* inArrivo: la lettura e' partita e non e' ancora tornata. Chi mostra
     i tasti di prima quando le regole mancano (la prenotazione, con un
     servizio vecchio) aspetta invece di farli lampeggiare. */
  const [stato, setStato] = useState({regole: null, inArrivo: carica});
  useEffect(() => {
    if (!carica) {
      setStato({regole: null, inArrivo: false});
      return undefined;
    }
    setStato({regole: null, inArrivo: true});
    let vivo = true;
    leggiRegoleStampa(io || null).then((r) => {
      if (vivo) setStato({regole: r, inArrivo: false});
    });
    return () => { vivo = false; };
  }, [io, carica]);
  return stato;
}

export function useRegoleStampa(io, opzioni) {
  return useRegoleStampaConStato(io, opzioni).regole;
}
